<div id="Map-Search">
    <button mat-fab (click)="click()" matTooltip="search" color="Accent">
        <mat-icon>search</mat-icon>
    </button>
</div>